import { useEffect } from "react";
import { useCubeDataDispatch } from "../contexts/CubeDataContext";

export default function useGetCubeMetaData() {
    const cubeDataDispatch = useCubeDataDispatch();
    useEffect(() => {
        cubeDataDispatch({
            type: "setIsLoadingMetaData",
            payload: true,
        });
        fetch("/api/cube/meta", {credentials: 'include'})
            .then((response) => response.json())
            .then((r) => {
                cubeDataDispatch({
                    type: "setCubeMetaData",
                    payload: r,
                });
                cubeDataDispatch({
                    type: "setIsLoadingMetaData",
                    payload: false,
                });
            });
    }, [cubeDataDispatch]);
}
